import React, { useContext } from 'react';
import { I18nReactContext } from '../../../../../../contexts/I18nContext';

/**
 * Remove background section for background image/video components
 * @param {object} props - Component props
 * @param {object} props.component - The component being edited
 * @param {function} props.onContentChange - Callback when content changes
 * @param {function} props.onClose - Callback to close the drawer
 */
export const RemoveBackgroundSection = ({ component, onContentChange, onClose }) => {
    const { i18n } = useContext(I18nReactContext);

    const isBackgroundImage = component?.type === 'backgroundImage';
    const isBackgroundVideo = component?.type === 'backgroundVideo';

    if (!isBackgroundImage && !isBackgroundVideo) {
        return null;
    }

    const translationKey = isBackgroundImage
        ? 'weezbeeCourse.editor.backgroundImageEditor.remove'
        : 'weezbeeCourse.editor.backgroundVideoEditor.remove';

    const handleRemove = () => {
        onContentChange(component.id, null);
        onClose();
    };

    return (
        <div className="menu-section">
            <button
                className="remove-button"
                onClick={handleRemove}
            >
                {i18n.translate(translationKey)}
            </button>
        </div>
    );
};
